import styled from "styled-components";
import { Row, Input, Col } from "antd";
import { PrimaryButtonComponent } from "../../../../commonStyles";

const { TextArea } = Input;

export const DrawerHeader = styled.h2`
  line-height: 1.17;
  letter-spacing: 0.5px;
  font-size: 36px;
  color: #022737;
  font-family: BerkeleyStd-Book;
  margin: 0px;
  @media only screen and (max-width: 425px) {
  font-size:30px;
  }
`;

export const BottomHeader = styled.h3`
  line-height: 36px;
  font-size: 24px;
  color: #022737;
  letter-spacing: 0.5px;
  font-family: berkeleyStd;
  margin-bottom: 5px;
  @media only screen and (max-width: 991px) {
    margin-bottom: 4px;
  }
`;

export const DescriptionPara = styled.p`
  color: #505050;
  line-height: 1.5;
  padding-top: 15px;
  font-family: HelveticaNeue;
  font-size: 16px;
  margin: 0px;
  @media only screen and (max-width: 425px) {
    font-size:14px;
    padding-top: 0px;
    }
`;

export const FaqLinkPara = styled.p`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  letter-spacing: normal;
  color: #022737;
  line-height: 1.5;
  margin: 0px;
  padding: 30px 0;
  @media only screen and (max-width: 560px) {
    font-size: 14px;
    line-height: 1.43;
  }
  @media only screen and (max-width: 991px) {
    padding: 20px 0 13px 0;
  }
`;

export const HR = styled.hr`
  color: filledTabsInactive;
`;

export const FundFromPara = styled.p`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #505050;
  padding: 28px 0 30px 0;
  margin: 0px;
  @media only screen and (max-width: 991px) {
    padding: 13px 0 30px 0;
  }
  @media only screen and (max-width: 425px) {
    font-size:14px;
    }
`;

export const FundFrom = styled.span`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  letter-spacing: normal;
  line-height: 1.5;
  color: #022737;
  @media only screen and (max-width: 425px) {
    font-size:14px;
    }
`;

export const RowWrapper = styled(Row)`
  padding: 0px 0px 22px 0px;
  @media only screen and (max-width: 560px) {
    padding: 0px 0px 12px 0px;
  }
`;

export const InputRowWrapper = styled(Row)`
margin: 0px;
  @media only screen and (max-width: 991px) {
    display: flex;
    flex-direction: column;
    padding: 0px;
  }
`;

export const TextAreaColWrapper = styled(Col)`
  padding: ${props => props.spacing};
  @media only screen and (max-width: 991px) {
    padding: 0px;
    width: 100%;
    margin-bottom: 8px;
  }
`;

export const InputHeader = styled.div`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #505050;
  font-family: HelveticaNeue;
  padding-bottom: 10px;
  @media only screen and (max-width: 425px) {
    font-size:14px;
    }
`;

export const SubmitButton = styled.div`
 
  
  margin-bottom: 53px;
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
  @media only screen and (min-width:768px) and (max-width: 991px) {
    margin-bottom: 40px;
    width: 200px;
  }
`;

export const Ahref = styled.a`
  font-size: 16px;
  letter-spacing: 0.08px;
  font-family: HelveticaNeue-Bold;
  color:#006778;
  text-decoration: underline;
  :hover{
    color:#006778;
  }
`

